module.exports = __webpack_public_path__ + "img/copy_icon.bc030bc7.svg";